import { Box, Chip, Typography } from '@mui/material';

import type { NormalizedModuleItem, SelectionKey } from '../../types/merge-customization';

import { ModuleItem } from './ModuleItem';

interface PatientModuleCardProps {
  moduleName: string;
  items: NormalizedModuleItem[];
  selections: Set<SelectionKey>;
  onToggleItem: (key: SelectionKey) => void;
  isDuplicate: (key: SelectionKey) => boolean;
  patientColor: string;
}

export function PatientModuleCard({
  moduleName,
  items,
  selections,
  onToggleItem,
  isDuplicate,
  patientColor,
}: PatientModuleCardProps) {
  const selectedCount = items.filter(i => selections.has(i.selectionKey)).length;

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1.5,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 1.5,
          py: 0.75,
          backgroundColor: 'grey.50',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="caption" fontWeight={600} sx={{ flex: 1 }}>
          {moduleName.charAt(0).toUpperCase() + moduleName.slice(1).replace(/_/g, ' ')}
        </Typography>
        <Chip
          label={`${selectedCount}/${items.length}`}
          size="small"
          color={selectedCount === items.length ? 'success' : 'default'}
          variant="outlined"
          sx={{ height: 20, fontSize: '0.7rem' }}
        />
      </Box>

      <Box sx={{ px: 0.5, py: 0.5 }}>
        {items.map(item => (
          <ModuleItem
            key={item.selectionKey}
            item={item}
            isSelected={selections.has(item.selectionKey)}
            isDuplicate={isDuplicate(item.selectionKey)}
            onToggle={onToggleItem}
            patientColor={patientColor}
            showPatientChip={false}
          />
        ))}
        {items.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ px: 1.5, py: 1 }}>
            No items
          </Typography>
        )}
      </Box>
    </Box>
  );
}
